import React from 'react';
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';

const TimeReferenceDropDown = ({ ...props }) => {
  const text = useTextResources();
  const types = [
    {
      Id: 0,
      Name: text('BeforeArrivalDate'),
    },
    {
      Id: 1,
      Name: text('AfterArrivalDate'),
    },
  ];
  return (
    <DropDown
      search={false}
      data={types}
      textField='Name'
      valueField='Id'
      {...props}
    />
  );
};

export default TimeReferenceDropDown;
